import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import '../css/header.css'; 

// --- SVG Icons for a Professional Look ---
// Using inline SVGs is better for performance and styling.
const StudentsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 12.75a.75.75 0 00.75-.75v-4.5a.75.75 0 00-1.5 0v4.5a.75.75 0 00.75.75z" />
        <path fillRule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 18a.75.75 0 00.75.75h16.5a.75.75 0 00.75-.75V6a.75.75 0 00-.75-.75H3.75a.75.75 0 00-.75.75v12z" clipRule="evenodd" />
        <path d="M12 12.75a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v4.5a.75.75 0 01-.75.75z" />
        <path d="M8.25 12.75a.75.75 0 00.75-.75v-1.5a.75.75 0 00-1.5 0v1.5a.75.75 0 00.75.75z" />
        <path d="M15.75 12.75a.75.75 0 00.75-.75v-1.5a.75.75 0 00-1.5 0v1.5a.75.75 0 00.75.75z" />
    </svg>
);

const ReportIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path fillRule="evenodd" d="M3 3.75A.75.75 0 013.75 3h16.5a.75.75 0 01.75.75v16.5a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75V3.75zM9 6a.75.75 0 01.75.75v10.5a.75.75 0 01-1.5 0V6.75A.75.75 0 019 6zm6.75 3a.75.75 0 00-1.5 0v7.5a.75.75 0 001.5 0v-7.5z" clipRule="evenodd" />
    </svg>
);

const RequestsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path fillRule="evenodd" d="M12 2.25a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3a.75.75 0 01.75-.75zm-9 13.5a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0v-2.25a.75.75 0 01.75-.75zm16.5 0a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0v-2.25a.75.75 0 01.75-.75z" clipRule="evenodd" />
    </svg>
);

const AllocateIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M4.5 6.375a.75.75 0 01.75-.75h13.5a.75.75 0 01.75.75v11.25a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V6.375z" />
        <path fillRule="evenodd" d="M12 8.25a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z" clipRule="evenodd" />
        <path fillRule="evenodd" d="M12 15a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H12.75A.75.75 0 0112 15z" clipRule="evenodd" />
        <path d="M8.25 11.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75z" />
        <path d="M13.5 11.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5H14.25a.75.75 0 01-.75-.75z" />
    </svg>
);

const LogoutIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm10.72 4.72a.75.75 0 011.06 0l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72H9a.75.75 0 010-1.5h10.94l-1.72-1.72a.75.75 0 010-1.06z" clipRule="evenodd" />
    </svg>
);


const Header = () => {
    const role = Cookies.get('role');
    // const navigate = useNavigate();

    const handleLogout = () => {
        Swal.fire({
            title: 'Are you sure?', 
            text: "You will be logged out! Do you want to continue?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, logout!'
        }).then((result) => {
            if (result.isConfirmed) {
                Cookies.remove('role');
                Cookies.remove('token');
                Cookies.remove('username');
                Cookies.remove('email');
                // navigate('/login');
                window.location.reload(); 
                window.location.href = '/login';
            }
        });
    };

    return (
        <header className="header">
            <div className="logosec">
                <NavLink to="/students-data" className="logo-link">
                    <img src="/images/ethiccraft_full_logo.png" alt="EthicCraft Logo" className="logo-img" />
                </NavLink>
            </div>

            <nav className="nav-links" role="navigation">
                <NavLink to="/students-data" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} defaultChecked>
                    <StudentsIcon />
                    <span>Students Data</span>
                </NavLink>
                {role === 'facilitator' && (
                    <NavLink to="/report" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}>
                        <ReportIcon />
                        <span>Report</span>
                    </NavLink>
                )}
                {role !== 'facilitator' && (
                    <>
                        <NavLink to="/requests" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}>
                            <RequestsIcon />
                            <span>Requests</span>
                        </NavLink>
                        <NavLink to="/Allocate" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}>
                            <AllocateIcon />
                            <span>Allocate</span>
                        </NavLink>
                    </>
                )}
            </nav>

            <div className="header-actions">
                <button onClick={handleLogout} className="nav-item logout-btn">
                    <LogoutIcon />
                    <span>Logout as {role}</span>
                </button>
            </div>
        </header>
    );
};

export default Header;